export default __webpack_public_path__ + "static/media/nesto_secure_logo_en.2a05362e.png";